import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Pressable } from 'react-native';

export function SectionHeader({
  title,
  onViewMore,
  onViewMoreText,
  onShowLessText,
}: {
  title: string;
  onViewMore?: () => void;
  onViewMoreText?: string;
  onShowLessText?: string;
}) {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const { t } = useTranslation();

  return (
    <Row justifyContent="space-between" alignItems="center">
      <Text fontSize={20} fontWeight="700" lineHeight={24} variant="bodyBase">
        {title}
      </Text>
      {onViewMore ? (
        <Pressable
          onPress={() => {
            onViewMore();
            setIsExpanded(!isExpanded);
          }}
        >
          <Text color="text.interactive" fontSize={14} fontWeight="600">
            {isExpanded
              ? (onShowLessText ?? t('landing-page:showLess'))
              : (onViewMoreText ?? t('landing-page:viewMore'))}
          </Text>
        </Pressable>
      ) : null}
    </Row>
  );
}
